import React from "react";
import SEO from "../components/SEO";

const PrivacyPolicyPage = () => {
  return (
    <div className="pt-20">
      <SEO
        title="Privacy Policy | Bar Spot Ltd"
        description="Bar Spot Ltd privacy policy. How we collect, use and protect your personal data in compliance with UK GDPR."
        canonical="/privacy-policy"
      />
      <section className="py-20 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="text-4xl md:text-5xl mb-8">Privacy Policy</h1>
          <div className="prose prose-lg text-[#444444]">
            <p className="text-sm text-[#666666] mb-8">Last updated: January 2026</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">1. Introduction</h2>
            <p className="mb-4">Bar Spot Ltd ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">2. Information We Collect</h2>
            <p className="mb-4">We may collect information about you in a variety of ways:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li><strong>Personal Data:</strong> Name, email address, telephone number, postal address, and other contact details you provide when making inquiries or bookings.</li>
              <li><strong>Event Information:</strong> Details about your event including date, location, guest numbers, and preferences.</li>
              <li><strong>Usage Data:</strong> Information about how you use our website, including IP address, browser type, and pages visited.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">3. How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Process and manage your booking inquiries</li>
              <li>Communicate with you about our services</li>
              <li>Provide customer support</li>
              <li>Improve our website and services</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">4. Legal Basis for Processing (UK GDPR)</h2>
            <p className="mb-4">We process your personal data on the following legal bases:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li><strong>Contract:</strong> Processing necessary to perform our contract with you</li>
              <li><strong>Legitimate Interests:</strong> Processing necessary for our legitimate business interests</li>
              <li><strong>Consent:</strong> Where you have given specific consent for processing</li>
              <li><strong>Legal Obligation:</strong> Processing necessary to comply with the law</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">5. Data Sharing and Disclosure</h2>
            <p className="mb-4">We may share your information with:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Service providers who assist in our operations</li>
              <li>Venues and event partners (with your consent)</li>
              <li>Legal authorities when required by law</li>
            </ul>
            <p className="mb-4">We do not sell your personal data to third parties.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">6. Data Security</h2>
            <p className="mb-4">We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">7. Data Retention</h2>
            <p className="mb-4">We retain your personal data only for as long as necessary to fulfil the purposes for which it was collected, including legal, accounting, or reporting requirements. Typically, booking records are retained for 7 years.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">8. Your Rights</h2>
            <p className="mb-4">Under UK data protection law, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Access your personal data</li>
              <li>Rectify inaccurate data</li>
              <li>Request erasure of your data</li>
              <li>Restrict processing of your data</li>
              <li>Data portability</li>
              <li>Object to processing</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p className="mb-4">To exercise these rights, please contact us at hello@barspotltd.co.uk.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">9. Cookies</h2>
            <p className="mb-4">Our website uses cookies to enhance your experience. You can control cookie settings through your browser. For more information, see our cookie notice on the website.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">10. Changes to This Policy</h2>
            <p className="mb-4">We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated revision date.</p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">11. Contact Us</h2>
            <p className="mb-4">If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
            <p className="mb-4">
              <strong>Bar Spot Ltd</strong><br />
              Unit A, 82 James Carter Road<br />
              Mildenhall, Suffolk, IP28 7DE<br />
              Email: hello@barspotltd.co.uk<br />
              Phone: 07554 856712
            </p>

            <h2 className="text-2xl font-semibold text-[#1a1a1a] mt-8 mb-4">12. Supervisory Authority</h2>
            <p className="mb-4">You have the right to lodge a complaint with the Information Commissioner's Office (ICO) if you believe we have not handled your personal data properly. The ICO can be contacted at ico.org.uk.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
